
import useSession from "./useSession";

const useSupabaseAuth = () => {
  const { session, loading, refresh } = useSession();
  return { 
    session, 
    loading, 
    refresh,
    user: session?.user || null 
  };
};

export default useSupabaseAuth;
